import React, { memo } from 'react'

import CustomDialog from '../../shared/CustomDialog/CustomDialog'

const Confirmation = ({
  t,
  title,
  description,
  cancelLabel,
  submitLabel,
  submitProps,
  isProcessing,
  ...restProps
}) => {
  return (
    <CustomDialog
      title={t(title)}
      description={t(description)}
      open
      cancelProps={cancelLabel && { label: t(cancelLabel) }}
      submitProps={{
        label: t(submitLabel),
        disabled: isProcessing,
        ...submitProps
      }}
      t={t}
      {...restProps}
    />
  )
}

export default memo(Confirmation)
